<template>
	<section class="availability-progress">
		<p class="availability-progress__text">
			{{ t('shoppingcart.availabilitycheck.progress.text', {checked: props.checked, total: props.total}) }}
		</p>

		<div class="availability-progress__row">
			<progress :aria-label="t('shoppingcart.availabilitycheck.progress.label')"
			          :max="props.total"
			          :value="props.checked"
			          class="availability-progress__bar">
				{{ percentage }}%
			</progress>

			<button v-if="props.cancellable"
			        :aria-label="t('shoppingcart.availabilitycheck.stop.text')"
			        :title="t('shoppingcart.availabilitycheck.stop.text')"
			        class="availability-progress__stop"
			        type="button"
			        @click="emits('stop')">

				<svg class="icon-modal-close" height="10" width="10">
					<use xlink:href="/assets/images/build/svg-sprite.min.svg#modal-close"></use>
				</svg>
			</button>
		</div>

	</section>
</template>

<script lang="ts" setup>
	import {computed} from 'vue';
	import {useI18n} from 'vue-i18n';

	const props = withDefaults(defineProps<{
		checked: number;
		total: number;
		cancellable?: boolean;
	}>(), {
		cancellable: true
	});

	const emits = defineEmits<{
		(e: 'stop'): void
	}>();

	const {t} = useI18n();

	const percentage = computed(() => {
		if (props.total <= 0) {
			return 0;
		}

		return Math.round((props.checked / props.total) * 100);
	});
</script>

<style scoped>
	.availability-progress {
		margin: 1rem 0;
	}

	.availability-progress__text {
		margin-bottom: .5rem;
	}

	/* Size and brand colors of the bar live in components/_shoppingcart-po.scss: only that partial is recompiled
	   with the Syngenta brand colors. */
	.availability-progress__row {
		align-items: center;
		display: flex;
		gap: .5rem;
	}

	.availability-progress__stop {
		background: none;
		border: 0;
		cursor: pointer;
		flex: 0 0 auto;
		line-height: 0;
		opacity: .5;
		padding: 4px;
	}

	.availability-progress__stop:hover {
		opacity: 1;
	}
</style>
